import React, { useMemo } from "react";
import CardBody from "../../../components/Card/CardBody";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Card from "../../../components/Card/Card";
import { FormLabel, Grid, MenuItem } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import {
  instoreMultiSAOrientations,
  instoreScreenTypes,
  kioskCartButtonTypes,
  kioskCheckboxBorderTypes,
  kioskCheckboxTypes,
  kioskCustomFieldsTypes,
  kioskProductOptionsGridWidths,
  kioskProductOptionsPopupThemes,
  kioskShowVoucherInformationTypes,
  selectableKioskV2Languages,
} from "../../../variables/app";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormColorTC from "../../../components/Forms/FormColorTC";
import FormJson from "../../../components/Forms/FormJson";
import FormFile from "../../../components/Forms/FormFile";
import { useWatch } from "react-hook-form";

function Kiosk() {
  //Dropdown opties
  const kioskProductOptionsPopupThemes_options = useMemo(
    () => convertArrayToSelectOptions(kioskProductOptionsPopupThemes),
    []
  );
  const kioskProductOptionsGridWidths_options = useMemo(
    () => convertArrayToSelectOptions(kioskProductOptionsGridWidths),
    []
  );
  const kioskCartButtonTypes_options = useMemo(() => convertArrayToSelectOptions(kioskCartButtonTypes), []);
  const kioskCheckboxTypes_options = useMemo(() => convertArrayToSelectOptions(kioskCheckboxTypes), []);
  const kioskCustomFieldsTypes_options = useMemo(() => convertArrayToSelectOptions(kioskCustomFieldsTypes), []);
  const kioskShowVoucherInformationTypes_options = useMemo(
    () => convertArrayToSelectOptions(kioskShowVoucherInformationTypes),
    []
  );
  const kioskCheckboxBorderTypes_options = useMemo(() => convertArrayToSelectOptions(kioskCheckboxBorderTypes), []);
  const instoreScreenTypes_options = useMemo(() => convertArrayToSelectOptions(instoreScreenTypes), []);
  const instoreMultiSAOrientations_options = useMemo(() => convertArrayToSelectOptions(instoreMultiSAOrientations), []);

  const appTarget = useWatch({ name: "appTarget" });
  const extra_settings__instoreScreenType = useWatch({ name: "extra_settings__instoreScreenType" });
  const extra_settings__showLangselKiosk = useWatch({ name: "extra_settings__showLangselKiosk" });
  const extra_settings__kioskCartButtonType = useWatch({ name: "extra_settings__kioskCartButtonType" });
  const extra_settings__kioskCheckboxType = useWatch({ name: "extra_settings__kioskCheckboxType" });

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Limieten"} tKey={"vestigingen.form.algemeen.headers.limieten"} />
              </h3>
            </Grid>
            <FormSwitchTC
              name={"orderLimits"}
              tDefault={"Order limieten gebruiken"}
              tKey={"vestigingen.form.overige.label.orderLimits"}
            />
            <FormControlledInputTC
              name={"minOrderValue"}
              tDefault={"Min order value"}
              tKey={"vestigingen.form.overige.label.minOrderValue"}
              type={"currency"}
            />
            <FormControlledInputTC
              name={"maxOrderValue"}
              tDefault={"Max order value"}
              tKey={"vestigingen.form.overige.label.maxOrderValue"}
              type={"currency"}
            />
            <FormSwitchTC name={"extra_settings__voucherShowKeyboard"} tKey={"Show Voucher-Keyboard"} />
            <FormSwitchTC
              name={"printWithAPI"}
              tDefault={"Printbon"}
              tKey={"vestigingen.form.zuil.label.printWithAPI"}
            />
            <FormSwitchTC name={"printVat"} tDefault={"Print btw"} tKey={"vestigingen.form.zuil.label.printVat"} />
            <FormTextTC
              name={"instoreAfterOrderUrl"}
              tDefault={"Url after order"}
              tKey={"vestigingen.form.zuil.label.instoreAfterOrderUrl"}
            />
            <FormControlledInputTC
              name={"afterOrderTimeout"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              tDefault={"Url after order timeout"}
              tKey={"vestigingen.form.zuil.label.afterOrderTimeout"}
              type={"number"}
            />
            <FormControlledInputTC
              name={"refreshTimeout"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              tDefault={"Logout after number of seconds"}
              tKey={"vestigingen.form.zuil.label.refreshTimeout"}
              type={"number"}
            />
            <Grid item xs={4}>
              <TranslationWrapper tDefault={"Kiosk background"} tKey={"vestigingen.form.zuil.label.kioskBackground"} />
              <FormFile canCrop={true} name={"extra_settings__kioskBackground"} nullable={true} type={"image"} />
            </Grid>
            <Grid item xs={4}>
              <TranslationWrapper
                tDefault={"Gesloten background"}
                tKey={"vestigingen.form.zuil.label.closeBackground"}
              />
              <FormFile canCrop={true} name={"extra_settings__closeBackground"} nullable={true} type={"image"} />
            </Grid>
            <Grid item xs={4}>
              <TranslationWrapper tDefault={"Background video"} tKey={"vestigingen.form.zuil.label.backgroundVideo"} />
              <FormFile name={"extra_settings__backgroundVideo"} nullable={true} type={"video"} />
            </Grid>
            <FormTextTC
              name={"extra_settings__extra1"}
              tDefault={"Kiosk custom extra 1"}
              tKey={"vestigingen.form.zuil.label.extra1"}
            />
            <FormTextTC
              name={"extra_settings__extra2"}
              tDefault={"Kiosk custom extra 2"}
              tKey={"vestigingen.form.zuil.label.extra2"}
            />
          </Grid>

          {appTarget == "app_woktogo.js" ? (
            <Grid container spacing={1} style={{ maxWidth: 1400 }}>
              <FormSwitchTC
                name={"extra_settings__eatinTakeSelection"}
                tDefault={"Eatin/Takeaway selection"}
                tKey={"vestigingen.form.zuil.label.showEatinTakeawaySelect"}
              />
            </Grid>
          ) : null}

          {/* ------------------------- */}
          {/* ---   KIOSKV2 ONLY    --- */}
          {/* ------------------------- */}
          {appTarget == "app_kioskv2.js" ? (
            <>
              <Grid container spacing={1} style={{ maxWidth: 1400 }}>
                <Grid item xs={12}>
                  <hr />
                  <h2>
                    <TranslationWrapper tDefault={"KioskV2 settings"} tKey={"vestigingen.form.zuil.kioskv2Settings"} />
                  </h2>
                </Grid>
                <Grid item xs={12}>
                  <hr />
                  <h3>
                    <strong>
                      <TranslationWrapper tDefault={"Front page"} tKey={"vestigingen.form.zuil.kioskFrontPage"} />
                    </strong>
                  </h3>
                </Grid>
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Layout & behaviour"}
                        tKey={"vestigingen.form.zuil.kioskFrontPage_layout"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormSelectTC
                  name={"extra_settings__instoreScreenType"}
                  options={instoreScreenTypes_options}
                  tDefault={"Frontpage type"}
                  tKey={"vestigingen.form.zuil.label.instoreScreenType"}
                />

                {extra_settings__instoreScreenType === 1 ? (
                  <>
                    <FormSelectTC
                      name={"extra_settings__instoreMultiSAOrientation"}
                      options={instoreMultiSAOrientations_options}
                      tDefault={"Orientation"}
                      tKey={"vestigingen.form.zuil.label.instoreMultiSAOrientation"}
                    />
                    <FormTextTC
                      name={"extra_settings__instoreMultiSAWebcodes"}
                      tDefault={"Webcode-list (csv)"}
                      tKey={"vestigingen.form.zuil.label.instoreMultiSAWebcodes"}
                    />
                    <FormTextTC
                      name={"extra_settings__instoreMultiSAButtonText"}
                      tDefault={"Buttontext-list (csv)"}
                      tKey={"vestigingen.form.zuil.label.instoreMultiSAButtonText"}
                    />
                    <Grid item xs={4}>
                      <TranslationWrapper
                        tDefault={"instoreMultiSAImage1"}
                        tKey={"vestigingen.form.zuil.label.instoreMultiSAImage1"}
                      />
                      <FormFile
                        canCrop={true}
                        name={"extra_settings__instoreMultiSAImage1"}
                        nullable={true}
                        type={"image"}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TranslationWrapper
                        tDefault={"instoreMultiSAImage2"}
                        tKey={"vestigingen.form.zuil.label.instoreMultiSAImage2"}
                      />
                      <FormFile
                        canCrop={true}
                        name={"extra_settings__instoreMultiSAImage2"}
                        nullable={true}
                        type={"image"}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TranslationWrapper
                        tDefault={"instoreMultiSAImage3"}
                        tKey={"vestigingen.form.zuil.label.instoreMultiSAImage3"}
                      />
                      <FormFile
                        canCrop={true}
                        name={"extra_settings__instoreMultiSAImage3"}
                        nullable={true}
                        type={"image"}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TranslationWrapper
                        tDefault={"instoreMultiSAImage4"}
                        tKey={"vestigingen.form.zuil.label.instoreMultiSAImage4"}
                      />
                      <FormFile
                        canCrop={true}
                        name={"extra_settings__instoreMultiSAImage4"}
                        nullable={true}
                        type={"image"}
                      />
                    </Grid>
                  </>
                ) : null}

                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Language flags"}
                        tKey={"vestigingen.form.zuil.kioskFrontPage_flags"}
                      />
                    </strong>
                  </h4>
                </Grid>

                {extra_settings__instoreScreenType !== 1 ? ( // don't show when instoreScreenType is set to salesarea-select
                  <>
                    <FormSwitchTC
                      name={"extra_settings__showLangselKiosk"}
                      tDefault={"Enabled language selection"}
                      tKey={"vestigingen.form.algemeen.label.showLangselKiosk"}
                    />
                    <Grid item xs={12}>
                      <TranslationWrapper
                        tDefault={"(Country flag language selection buttons)"}
                        tKey={"vestigingen.form.algemeen.label.showLangselKiosk_extraInfo"}
                      />
                    </Grid>
                  </>
                ) : (
                  <Grid xs={12}>
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Not applicable. (Not used in sales-area-selection mode)."}
                        tKey={"vestigingen.form.algemeen.label.not_applicable"}
                      />
                    </FormLabel>
                  </Grid>
                )}

                {extra_settings__showLangselKiosk && extra_settings__instoreScreenType !== 1 ? (
                  <>
                    <FormSelectTC
                      fieldProps={({ value, onChange }) => ({
                        onChange: (e) => {
                          onChange(JSON.stringify(e.target.value));
                        },
                        value: value ? JSON.parse(value) : [],
                        multiple: true,
                      })}
                      multiple={true}
                      name={"extra_settings__showLangselKioskLanguages"}
                      options={Object.values(selectableKioskV2Languages).map((lang) => (
                        <MenuItem value={lang.value}>{lang.label}</MenuItem>
                      ))}
                      tKey={"vestigingen.form.algemeen.label.kioskLanguages"}
                    />
                    <FormControlledInputTC
                      name={"extra_settings__kioskFrontPageFlagsZoomfactor"}
                      tDefault={"Zoom-factor flags"}
                      tKey={"vestigingen.form.algemeen.label.kioskFrontPageFlagsZoomfactor"}
                      type={"number"}
                    />
                    <FormControlledInputTC
                      name={"extra_settings__kioskFrontPageFlagsMargin"}
                      tDefault={"Vertical-offset language flags"}
                      tKey={"vestigingen.form.algemeen.label.kioskFrontPageFlagsMargin"}
                      type={"number"}
                    />
                  </>
                ) : null}
                {/* ------------------------------------------------------------------------------------- */}
              </Grid>
              <Grid container spacing={1} style={{ maxWidth: 1400 }}>
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper tDefault={"Buttons"} tKey={"vestigingen.form.zuil.kioskFrontPage_buttons"} />
                    </strong>
                  </h4>
                </Grid>

                {extra_settings__instoreScreenType !== 1 ? ( // don't show when instoreScreenType is set to salesarea-select
                  <>
                    <FormSwitchTC
                      name={"extra_settings__showTakeAway"}
                      tDefault={"Show button 1"}
                      tKey={"vestigingen.form.algemeen.label.showTakeAway"}
                    />
                    <Grid item xs={12}>
                      <TranslationWrapper
                        tDefault={'(Single button mode: "Order Here" , Duo button mode: "TakeAway")'}
                        tKey={"vestigingen.form.algemeen.label.showTakeAway_extraInfo"}
                      />
                    </Grid>
                    <FormSwitchTC
                      name={"extra_settings__showEatIn"}
                      tDefault={"Show button 2"}
                      tKey={"vestigingen.form.algemeen.label.showEatIn"}
                    />
                    <Grid item xs={12}>
                      <TranslationWrapper
                        tDefault={"(Eat in button)"}
                        tKey={"vestigingen.form.algemeen.label.showEatIn_extraInfo"}
                      />
                    </Grid>
                  </>
                ) : null}
                <FormColorTC
                  name={"extra_settings__kioskFrontPageButtonColor"}
                  nullable={true}
                  tDefault={"Text color (optional)"}
                  tKey={"vestigingen.form.algemeen.label.kioskFrontpageButtonFontColor"}
                />
                <FormColorTC
                  name={"extra_settings__kioskFrontPageButtonBgColor"}
                  nullable={true}
                  tDefault={"Background color (optional)"}
                  tKey={"vestigingen.form.algemeen.label.kioskFrontpageButtonBgColor"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskFrontPageButtonsZoomfactor"}
                  tDefault={"Zoom-factor buttons"}
                  tKey={"vestigingen.form.algemeen.label.kioskFrontPageButtonsZoomfactor"}
                  type={"number"}
                />

                {extra_settings__instoreScreenType === 0 ? ( // show only when instoreScreenType is set to default
                  <FormControlledInputTC
                    name={"extra_settings__kioskFrontPageButtonsMargin"}
                    tDefault={"Vertical-offset buttons"}
                    tKey={"vestigingen.form.algemeen.label.kioskFrontPageButtonsMargin"}
                    type={"number"}
                  />
                ) : null}
                <Grid item xs={12}>
                  <hr />
                  <h3>
                    <strong>
                      <TranslationWrapper tDefault={"Main page"} tKey={"vestigingen.form.zuil.kioskMainPage"} />
                    </strong>
                  </h3>
                </Grid>
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Menu bar left"}
                        tKey={"vestigingen.form.zuil.kioskMainPage_menuBarLeft"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormSwitchTC
                  name={"extra_settings__showRestartIconKiosk"}
                  tDefault={"Show restart icon"}
                  tKey={"vestigingen.form.algemeen.label.kioskShowRestartIcon"}
                />

                {/* <GridContainer>
                  <GridItem xs={12} sm={2}>
                    <FormLabel className={classes.labelHorizontal}>
                      {
                        <TranslationWrapper
                          tKey={"vestigingen.form.algemeen.label.showScrollDownIconKiosk"}
                          tDefault={"Show scroll-down icon"}
                        />
                      }
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={2}>
                    <CustomSwitch
                      name="extra_settings__showScrollDownIconKiosk"
                      checked={props.parent.state.formdata.extra_settings__showScrollDownIconKiosk}
                      onChange={props.parent.handleCheckbox("extra_settings__showScrollDownIconKiosk")}
                    />
                  </GridItem>
                </GridContainer> */}
                {/* ------------------------------------------------------------------------------------- */}
                <FormControlledInputTC
                  name={"extra_settings__kioskMenuBarLeftZoomfactor"}
                  tDefault={"Zoom-factor menu bar left"}
                  tKey={"vestigingen.form.algemeen.label.kioskMenuBarLeftZoomfactor"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Product panel right"}
                        tKey={"vestigingen.form.zuil.kioskMainPage_productPanelRight"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormControlledInputTC
                  name={"extra_settings__kioskProductPanelRightZoomfactor"}
                  tDefault={"Zoom-factor product panel right"}
                  tKey={"vestigingen.form.algemeen.label.kioskProductPanelRightZoomfactor"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper tDefault={"Order Cart"} tKey={"vestigingen.form.zuil.kioskPopup_orderCart"} />
                    </strong>
                  </h4>
                </Grid>
                <FormSelectTC
                  name={"extra_settings__kioskCartButtonType"}
                  options={kioskCartButtonTypes_options}
                  tDefault={"Cart button type"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartButtonType"}
                />

                {extra_settings__kioskCartButtonType === 1 ? (
                  <>
                    <FormColorTC
                      name={"extra_settings__kioskCartButtonArea_fontColor"}
                      nullable={true}
                      tDefault={"Bottom area text color"}
                      tKey={"vestigingen.form.algemeen.label.kioskCartButtonArea_fontColor"}
                    />
                    <FormColorTC
                      name={"extra_settings__kioskCartButtonArea_backgroundColor"}
                      nullable={true}
                      tDefault={"Bottom area background color"}
                      tKey={"vestigingen.form.algemeen.label.kioskCartButtonArea_backgroundColor"}
                    />
                  </>
                ) : null}
                {extra_settings__kioskCartButtonType === 0 && false ? (
                  <FormColorTC
                    name={"extra_settings__kioskCartButtonArea_borderColor"}
                    nullable={true}
                    tDefault={"kioskCartButtonArea_borderColor"}
                    tKey={"vestigingen.form.algemeen.label.kioskCartButtonArea_borderColor"}
                  />
                ) : null}
                <FormControlledInputTC
                  name={"extra_settings__kioskCartButtonZoomfactor"}
                  tDefault={"Zoom-factor"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartButtonZoomfactor"}
                  type={"number"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskCartButtonHorizontalOffset"}
                  tDefault={"Horizontal-offset"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartButtonHorizontalOffset"}
                  type={"number"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskCartButtonVerticalOffset"}
                  tDefault={"Vertical-offset"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartButtonVerticalOffset"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                {extra_settings__kioskCartButtonType === 1 ? (
                  <>
                    <FormColorTC
                      name={"extra_settings__kioskCartAreaSubButton_fontColor"}
                      nullable={true}
                      tDefault={"Cart button text color"}
                      tKey={"vestigingen.form.algemeen.label.kioskCartAreaSubButton_fontColor"}
                    />
                    <FormColorTC
                      name={"extra_settings__kioskCartAreaSubButton_backgroundColor"}
                      nullable={true}
                      tDefault={"Cart button background color"}
                      tKey={"vestigingen.form.algemeen.label.kioskCartAreaSubButton_backgroundColor"}
                    />
                    <FormControlledInputTC
                      name={"extra_settings__kioskCartAreaSubButton_borderWidth"}
                      tDefault={"Cart button border size"}
                      tKey={"vestigingen.form.algemeen.label.kioskCartAreaSubButton_borderWidth"}
                      type={"number"}
                    />
                  </>
                ) : null}
                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <hr />
                  <h3>
                    <strong>
                      <TranslationWrapper tDefault={"Popup windows"} tKey={"vestigingen.form.zuil.kioskPopupWindows"} />
                    </strong>
                  </h3>
                </Grid>
                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Options"}
                        tKey={"vestigingen.form.zuil.kioskPopup_productOptions"}
                      />
                    </strong>
                  </h4>
                </Grid>
                <FormSelectTC
                  name={"extra_settings__kioskProductOptionsPopupTheme"}
                  options={kioskProductOptionsPopupThemes_options}
                  tDefault={"Custom Theme"}
                  tKey={"vestigingen.form.algemeen.label.kioskProductOptionsPopupTheme"}
                />
                <FormSelectTC
                  name={"extra_settings__kioskProductOptionsGridWidth"}
                  options={kioskProductOptionsGridWidths_options}
                  tDefault={"Horizontal grid size"}
                  tKey={"vestigingen.form.algemeen.label.kioskProductOptionsGridWidth"}
                />
                {/* ------------------------------------------------------------------------------------- */}
                <br />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonNext_fontColor"}
                  nullable={true}
                  tDefault={"Next-button text color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonNext_fontColor"}
                />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonNext_backgroundColor"}
                  nullable={true}
                  tDefault={"Next-button background color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonNext_backgroundColor"}
                />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonNext_borderColor"}
                  nullable={true}
                  tDefault={"Next-button border color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonNext_borderColor"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <FormControlledInputTC
                  name={"extra_settings__kioskOptionButtonNext_borderWidth"}
                  tDefault={"Next-button border size"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonNext_borderWidth"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <br />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonAdd_fontColor"}
                  nullable={true}
                  tDefault={"Add-button text color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonAdd_fontColor"}
                />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonAdd_backgroundColor"}
                  nullable={true}
                  tDefault={"Add-button background color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonAdd_backgroundColor"}
                />
                <FormColorTC
                  name={"extra_settings__kioskOptionButtonAdd_borderColor"}
                  nullable={true}
                  tDefault={"Add-button border color"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonAdd_borderColor"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskOptionButtonAdd_borderWidth"}
                  tDefault={"Add-button border size"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionButtonAdd_borderWidth"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <br />
                <FormSelectTC
                  name={"extra_settings__kioskCheckboxType"}
                  options={kioskCheckboxTypes_options}
                  tDefault={"Checkbox type"}
                  tKey={"vestigingen.form.algemeen.label.kioskCheckboxType"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                {/* ------------------------------------------------------------------------------------- */}
                {extra_settings__kioskCheckboxType === 1 ? (
                  <>
                    <FormSelectTC
                      name={"extra_settings__kioskCheckboxBorderType"}
                      options={kioskCheckboxBorderTypes_options}
                      tDefault={"Checkbox shape & border"}
                      tKey={"vestigingen.form.algemeen.label.kioskCheckboxBorderType"}
                    />

                    {/* ------------------------------------------------------------------------------------- */}
                    {/* <GridContainer>
              <GridItem xs={12} sm={2}>
                <FormLabel className={classes.labelHorizontal}>
                  {
                    <TranslationWrapper
                      tKey={"vestigingen.form.algemeen.label.kioskCheckbox_fontColor"}
                      tDefault={"Checkbox Font color"}
                    />
                  }
                </FormLabel>
              </GridItem>
              <GridItem xs={12} sm={8}>
                <ColorPicker
                  value={props.parent.state.formdata.extra_settings__kioskCheckbox_fontColor}
                  onChange={props.parent.handleColorChange}
                  name={"extra_settings__kioskCheckbox_fontColor"}
                  id={"extra_settings__kioskCheckbox_fontColor"}
                />
              </GridItem>
            </GridContainer> */}
                    {/* ------------------------------------------------------------------------------------- */}
                    {/* <GridContainer>
              <GridItem xs={12} sm={2}>
                <FormLabel className={classes.labelHorizontal}>
                  {
                    <TranslationWrapper
                      tKey={"vestigingen.form.algemeen.label.kioskCheckbox_bgColorChecked"}
                      tDefault={"Checkbox checked bg-color"}
                    />
                  }
                </FormLabel>
              </GridItem>
              <GridItem xs={12} sm={8}>
                <ColorPicker
                  value={props.parent.state.formdata.extra_settings__kioskCheckbox_bgColorChecked}
                  onChange={props.parent.handleColorChange}
                  name={"extra_settings__kioskCheckbox_bgColorChecked"}
                  id={"extra_settings__kioskCheckbox_bgColorChecked"}
                />
              </GridItem>
            </GridContainer> */}
                    {/* ------------------------------------------------------------------------------------- */}
                    {/* <GridContainer>
              <GridItem xs={12} sm={2}>
                <FormLabel className={classes.labelHorizontal}>
                  {
                    <TranslationWrapper
                      tKey={"vestigingen.form.algemeen.label.kioskCheckbox_bgColorUnchecked"}
                      tDefault={"Checkbox unchecked bg-color"}
                    />
                  }
                </FormLabel>
              </GridItem>
              <GridItem xs={12} sm={8}>
                <ColorPicker
                  value={props.parent.state.formdata.extra_settings__kioskCheckbox_bgColorUnchecked}
                  onChange={props.parent.handleColorChange}
                  name={"extra_settings__kioskCheckbox_bgColorUnchecked"}
                  id={"extra_settings__kioskCheckbox_bgColorUnchecked"}
                />
              </GridItem>
            </GridContainer> */}
                    {/* ------------------------------------------------------------------------------------- */}
                    {/* <GridContainer>
              <GridItem xs={12} sm={2}>
                <FormLabel className={classes.labelHorizontal}>
                  {
                    <TranslationWrapper
                      tKey={"vestigingen.form.algemeen.label.kioskCheckbox_bgColorHover"}
                      tDefault={"Checkbox hover bg-color"}
                    />
                  }
                </FormLabel>
              </GridItem>
              <GridItem xs={12} sm={8}>
                <ColorPicker
                  value={props.parent.state.formdata.extra_settings__kioskCheckbox_bgColorHover}
                  onChange={props.parent.handleColorChange}
                  name={"extra_settings__kioskCheckbox_bgColorHover"}
                  id={"extra_settings__kioskCheckbox_bgColorHover"}
                />
              </GridItem>
            </GridContainer> */}
                    {/* ------------------------------------------------------------------------------------- */}
                    <FormColorTC
                      name={"extra_settings__kioskCheckbox_borderColor"}
                      nullable={true}
                      tDefault={"Checkbox border-color"}
                      tKey={"vestigingen.form.algemeen.label.kioskCheckbox_borderColor"}
                    />
                  </>
                ) : null}
                {/* ------------------------------------------------------------------------------------- */}
                <br />

                <FormControlledInputTC
                  name={"extra_settings__kioskOptionSelectorHorizontalOffset"}
                  tDefault={"Selector: Horizontal-offset"}
                  tKey={"vestigingen.form.algemeen.label.kioskOptionSelectorHorizontalOffset"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper tDefault={"Order Cart"} tKey={"vestigingen.form.zuil.kioskPopup_orderCart"} />
                    </strong>
                  </h4>
                </Grid>

                <FormSelectTC
                  name={"extra_settings__kioskCustomFieldsType"}
                  options={kioskCustomFieldsTypes_options}
                  tDefault={"Customfields location"}
                  tKey={"vestigingen.form.algemeen.label.kioskCustomFieldsType"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskCartContinueOrderingButtonZoomfactor"}
                  tDefault={"Zoom-factor Continue Button"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartContinueOrderingButtonZoomfactor"}
                  type={"number"}
                />
                <FormControlledInputTC
                  name={"extra_settings__kioskCartOrderViewZoomfactor"}
                  tDefault={"Zoom-factor Cart Order View"}
                  tKey={"vestigingen.form.algemeen.label.kioskCartOrderViewZoomfactor"}
                  type={"number"}
                />
                <FormSelectTC
                  name={"extra_settings__kioskShowVoucherInformationType"}
                  options={kioskShowVoucherInformationTypes_options}
                  tDefault={"Voucher information"}
                  tKey={"vestigingen.form.algemeen.label.kioskShowVoucherInformationType"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper tDefault={"Restart"} tKey={"vestigingen.form.zuil.kioskPopup_restart"} />
                    </strong>
                  </h4>
                </Grid>
                <FormControlledInputTC
                  name={"extra_settings__kioskRestartPopupButtonsZoomfactor"}
                  tDefault={"Zoom-factor Restart Popup Buttons"}
                  tKey={"vestigingen.form.algemeen.label.kioskRestartPopupButtonsZoomfactor"}
                  type={"number"}
                />

                <FormControlledInputTC
                  name={"extra_settings__restartTimeout"}
                  tDefault={"Kiosk restart timeout"}
                  tKey={"vestigingen.form.algemeen.label.kioskRestartPopupButtonsTimeout"}
                  type={"number"}
                />

                {/* ------------------------------------------------------------------------------------- */}
                <Grid item xs={12}>
                  <h4>
                    <strong>
                      <TranslationWrapper
                        tDefault={"Custom Translations"}
                        tKey={"vestigingen.form.zuil.customTranslations"}
                      />
                    </strong>
                  </h4>
                </Grid>

                <GridContainer>
                  <GridItem sm={2} xs={12}>
                    <FormLabel>
                      <strong>Current supported objects:</strong>
                    </FormLabel>
                  </GridItem>
                  <GridItem sm={10} xs={12}>
                    <br />
                    kiosk_frontPage_orderHereButton
                    <br />
                    kiosk_frontPage_takeAwayButton
                    <br />
                    kiosk_frontPage_eatInButton
                    <br />
                    kiosk_mainPage_cartButton
                    <br />
                    kiosk_orderCart_continueOrderingButton
                    <br />
                    kiosk_orderCart_payButton <br />
                    kiosk_restart_restartButton <br />
                    kiosk_restart_continueOrderingButton <br />
                    kiosk_restart_title <br />
                    kiosk_restart_subtitle <br />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem sm={2} xs={12}>
                    <FormLabel>
                      <strong>Example:</strong>
                    </FormLabel>
                  </GridItem>
                  <GridItem sm={10} xs={12}>
                    <br />
                    &#91;&#123;&quot;object&quot;&#58;&quot;kiosk_mainPage_cartButton&quot;,&quot;language&quot;&#58;&quot;nl&quot;,&quot;text&quot;&#58;&quot;Bekijk
                    pakjesmand&quot;&#125;&#93;
                    <br />
                  </GridItem>
                </GridContainer>
                <FormJson
                  name={"extra_settings__customTranslations"}
                  tDefault={"custom Translations (JSON)"}
                  tKey={"vestigingen.form.algemeen.label.kioskCustomTranslations"}
                />
              </Grid>
            </>
          ) : null}
        </CardBody>
      </Card>
    </div>
  );
}

export default Kiosk;
